/* § 18-bekræftelse i kurven (P0 §6a, fase 18, 8/10-2026).
   Markup: snippets/ltd-s18-cart-confirm.liquid (kurvsiden sections/ltd-cart.liquid + Horizon-skuffen snippets/cart-summary.liquid).
   - Checkout-knapper ([name="checkout"]) i samme form/forælder er deaktiveret, indtil der er sat flueben.
   - Flueben gemmes som cart attribute «Bekræftet §18 personlige varer» = «Ja – <ISO-tidsstempel>» via /cart/update.js.
   - Fjernes fluebenet, slettes attributtet igen. Står der et gammelt attribut uden personlige varer (data-ltd-s18-stale), slettes det.
   Ingen afhængigheder; idempotent (kan indlæses flere gange). */
(function () {
  'use strict';
  if (window.__ltdS18Cart) return;
  window.__ltdS18Cart = true;
  var KEY = 'Bekræftet §18 personlige varer';
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  /* fase199 (forslag): kald køres ét ad gangen (svar kan ellers komme i forkert rækkefølge),
     og et midlertidigt fejlsvar (fx 429/5xx/netværk) prøves automatisk igen én gang, før fejlteksten vises. */
  var queue = Promise.resolve();
  function save(value) {
    var run = function () { return saveOnce(value).catch(function () { return new Promise(function (ok) { setTimeout(ok, 800); }).then(function () { return saveOnce(value); }); }); };
    var p = queue.then(run, run);
    queue = p.catch(function () {});
    return p;
  }
  function saveOnce(value) {
    var attrs = {};
    attrs[KEY] = value;
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update ' + r.status);
      return r.json();
    });
  }
  function scopeOf(box) {
    return box.closest('form') || box.parentElement || document;
  }
  function checkoutButtons(box) {
    var scope = scopeOf(box);
    var list = Array.prototype.slice.call(scope.querySelectorAll('[name="checkout"]'));
    var cb = box.querySelector('[data-ltd-s18-check]');
    var formId = cb && cb.getAttribute('form');
    if (formId) {
      document.querySelectorAll('[name="checkout"][form="' + formId + '"]').forEach(function (b) {
        if (list.indexOf(b) === -1 && scope.contains(b)) list.push(b);
      });
    }
    return list;
  }
  function sync(box) {
    var cb = box.querySelector('[data-ltd-s18-check]');
    if (!cb) return;
    var ok = cb.checked && !box.hasAttribute('data-ltd-s18-saving');
    checkoutButtons(box).forEach(function (b) {
      b.disabled = !ok;
      if (ok) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
    });
    var hint = box.querySelector('[data-ltd-s18-hint]');
    if (hint) hint.hidden = cb.checked;
    /* fase134: hjælpetekst ved den låste knap */
    scopeOf(box).querySelectorAll('[data-ltd-lock-hint]').forEach(function (h) { h.hidden = ok; });
  }
  function syncAll() {
    document.querySelectorAll('[data-ltd-s18]').forEach(sync);
    var stale = document.querySelector('[data-ltd-s18-stale]');
    if (stale && !document.querySelector('[data-ltd-s18]') && !busy) {
      busy = true;
      stale.removeAttribute('data-ltd-s18-stale');
      save('').catch(function () {}).then(function () { busy = false; });
    }
  }

  document.addEventListener('change', function (e) {
    var cb = e.target && e.target.closest ? e.target.closest('[data-ltd-s18-check]') : null;
    if (!cb) return;
    var box = cb.closest('[data-ltd-s18]');
    if (!box) return;
    var err = box.querySelector('[data-ltd-s18-error]');
    if (err) err.hidden = true;
    hideMsg();
    var value = cb.checked ? 'Ja – ' + new Date().toISOString() : '';
    if (value) cb.value = value;
    cb.setAttribute('data-ltd-s18-user', '');
    box.setAttribute('data-ltd-s18-saving', '');
    sync(box);
    save(value).then(function () {
      box.removeAttribute('data-ltd-s18-saving');
      sync(box);
    }).catch(function () {
      box.removeAttribute('data-ltd-s18-saving');
      cb.checked = false;
      if (err) err.hidden = false;
      sync(box);
    });
  });

  // Sikkerhedsnet: klik på en deaktiveret/ubekræftet checkout-knap (fx hvis en anden script har slået den til igen).
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[name="checkout"]') : null;
    if (!btn) return;
    var boxes = document.querySelectorAll('[data-ltd-s18]');
    for (var i = 0; i < boxes.length; i++) {
      var cb = boxes[i].querySelector('[data-ltd-s18-check]');
      if (checkoutButtons(boxes[i]).indexOf(btn) !== -1 && cb && (!cb.checked || boxes[i].hasAttribute('data-ltd-s18-saving'))) {
        e.preventDefault();
        e.stopImmediatePropagation();
        sync(boxes[i]);
        cb.focus();
        return;
      }
    }
    gate(e, btn);
  }, true);

  /* fase199b (Chef): «Til kassen» må aldrig føre videre uden et gemt §18-samtykke.
     Før videresendelse læses /cart.js, og attributtet skal starte med «Ja». Ellers blokeres og der vises en besked. */
  var MSG = 'Vi kunne ikke gemme din bekræftelse. Tjek din forbindelse og sæt fluebenet igen.';
  var verified = null;
  function boxFor(btn) {
    var boxes = document.querySelectorAll('[data-ltd-s18]');
    for (var i = 0; i < boxes.length; i++) if (checkoutButtons(boxes[i]).indexOf(btn) !== -1) return boxes[i];
    return null;
  }
  function showMsg(box, btn) {
    var scope = btn.parentElement || box;
    var m = scope.querySelector('[data-ltd-s18-checkout-msg]');
    if (!m) {
      m = document.createElement('p');
      m.setAttribute('data-ltd-s18-checkout-msg', '');
      m.setAttribute('role', 'alert');
      m.style.cssText = 'color:#b3261e;font-weight:600;font-size:14px;margin:8px 0 0';
      m.textContent = MSG;
      btn.insertAdjacentElement('afterend', m);
    }
    m.hidden = false;
    var cb = box.querySelector('[data-ltd-s18-check]');
    if (cb) { cb.checked = false; cb.removeAttribute('data-ltd-s18-user'); }
    sync(box);
  }
  function hideMsg() {
    document.querySelectorAll('[data-ltd-s18-checkout-msg]').forEach(function (m) { m.hidden = true; });
  }
  function gate(e, btn) {
    var box = boxFor(btn);
    if (!box) return;
    if (verified === btn) { verified = null; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (box.hasAttribute('data-ltd-s18-checking')) return;
    box.setAttribute('data-ltd-s18-checking', '');
    btn.disabled = true;
    queue.then(function () {
      return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
    }).then(function (r) {
      if (!r.ok) throw new Error('cart.js ' + r.status);
      return r.json();
    }).then(function (cart) {
      var v = cart && cart.attributes && cart.attributes[KEY];
      if (!v || String(v).indexOf('Ja') !== 0) throw new Error('ikke gemt');
      box.removeAttribute('data-ltd-s18-checking');
      btn.disabled = false;
      verified = btn;
      var f = btn.form;
      if (f && f.requestSubmit) f.requestSubmit(btn); else btn.click();
    }).catch(function () {
      box.removeAttribute('data-ltd-s18-checking');
      showMsg(box, btn);
    });
  }
  // Også formular-afsendelse uden klik (fx requestSubmit fra anden kode) går gennem samme kontrol.
  document.addEventListener('submit', function (e) {
    var btn = e.submitter;
    if (!btn || btn.name !== 'checkout') return;
    var box = boxFor(btn);
    if (!box) return;
    var cb = box.querySelector('[data-ltd-s18-check]');
    if (!cb || !cb.checked || box.hasAttribute('data-ltd-s18-saving')) { e.preventDefault(); e.stopImmediatePropagation(); sync(box); return; }
    gate(e, btn);
  }, true);

  /* fase134b (Legal): fluebenet må aldrig være sat ved indlæsning – heller ikke via autofill eller bfcache (pageshow).
     Kun et flueben sat af brugeren i samme sidevisning tæller. Et gemt attribut fra tidligere slettes. */
  function nulstil(ny) {
    var gemt = false;
    document.querySelectorAll('[data-ltd-s18-check]').forEach(function (cb) {
      if (ny) cb.removeAttribute('data-ltd-s18-user');
      if (cb.hasAttribute('data-ltd-s18-user')) return;
      cb.setAttribute('autocomplete', 'off');
      if (cb.checked) cb.checked = false;
      cb.defaultChecked = false; cb.value = 'Ja';
      if (cb.hasAttribute('data-ltd-s18-gemt')) { cb.removeAttribute('data-ltd-s18-gemt'); gemt = true; }
    });
    if (gemt && !busy) { busy = true; save('').catch(function () {}).then(function () { busy = false; }); }
    document.querySelectorAll('[data-ltd-s18]').forEach(sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { nulstil(false); }); else nulstil(false);
  window.addEventListener('pageshow', function (e) { nulstil(!!e.persisted); });
  window.addEventListener('load', function () { setTimeout(function () { nulstil(false); }, 0); });

  // Horizon-skuffen gen-renderes (morph) ved ændringer i kurven: synkronisér igen.
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(syncAll, 30); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll); else syncAll();
  if (window.MutationObserver) {
    var start = function () { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  }
})();
